import type { DealStage } from '../../types/deals'

// The pipeline vocabulary the Leads, Opportunities and lead pages share. Words only; the stages are the pack's.

export const STAGE_WORDS: Record<DealStage, string> = {
  none: 'no pursuit', lead: 'Lead', opportunity: 'Opportunity', proposal: 'Proposal out', negotiation: 'Negotiating', won: 'Won', lost: 'Lost', delivery: 'In delivery', dormant: 'Gone quiet',
}

/** Sort order for the list: the most advanced live pursuit first. */
export const STAGE_ORDER: DealStage[] = ['negotiation', 'proposal', 'opportunity', 'won', 'delivery', 'lead', 'dormant', 'lost', 'none']

/** The ladder a pursuit climbs; the side states (dormant, lost, delivery) hang off it. */
export const LADDER: DealStage[] = ['lead', 'opportunity', 'proposal', 'negotiation', 'won']

export const PERSONA_WORDS: Record<string, string> = {
  'decision-maker': 'Decision maker', champion: 'Champion', influencer: 'Influencer', challenger: 'Challenger', gatekeeper: 'Gatekeeper', user: 'User', other: 'Other',
}
export const PERSONA_ORDER = ['decision-maker', 'champion', 'influencer', 'challenger', 'gatekeeper', 'user', 'other']
export const PERSONA_GLYPH: Record<string, string> = { champion: '★', influencer: '◆', challenger: '▲', 'decision-maker': '■', gatekeeper: '●', user: '○', other: '' }
